import isMobile from "is-mobile";
import type { Config, ActivityConfig } from "../declarations/config";
import { getVideoUrl } from "./DPFunctions";
import { getMobileOperatingSystem } from "./Mobile";

export const generateConfig = (giftConfig: Config) => {
  const mobileOS = getMobileOperatingSystem();

  let activityConfig: ActivityConfig = {
    button: "Default",
    src: "",
    title: "",
    slug: "",
    thumbnail: "",
    description: "",
    type: "",
  };
  if (
    [
      "vanoce-a-pohadky-v-az-kvizu",
      "pohlednice",
      "tvorivy-duch-vanoc",
      "sala-po-spuntovsku",
    ].includes(giftConfig.slug)
  ) {
    activityConfig = {
      button: "Default",
      type:
        giftConfig.slug === "vanoce-a-pohadky-v-az-kvizu" ? "game" : "other",
      slug: giftConfig.slug,
      title: giftConfig.title,
      src: `/flashAppIframe/${giftConfig.uuid}?posterEnabled=false&closeButtonEnabled=false`,
      thumbnail: giftConfig.thumbnail ?? "activity-placeholder.png",
      description: giftConfig.description ?? "",
    };
  } else if (
    !isMobile({ tablet: true }) &&
    !(
      navigator.userAgent.includes("Mac") &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2
    )
  ) {
    if (giftConfig.type === "game") {
      activityConfig = {
        button: "Default",
        slug: giftConfig.slug,
        title: giftConfig.title,
        src: `/flashAppIframe/${giftConfig.uuid}?posterEnabled=false&closeButtonEnabled=false`,
        thumbnail: giftConfig.thumbnail ?? "activity-placeholder.png",
        description: giftConfig.description ?? "",
        type: "game",
      };
    } else if (giftConfig.type === "video") {
      activityConfig = {
        button: "Default",
        slug: giftConfig.slug,
        title: giftConfig.title,
        src: getVideoUrl(giftConfig.idec),
        thumbnail: giftConfig.thumbnail ?? "activity-placeholder.png",
        description: giftConfig.description ?? "",
        type: "video",
      };
    }
  } else {
    if (giftConfig.type === "game") {
      const isIOS = mobileOS === "iOS";
      const appLinks = isIOS
        ? giftConfig.appLinkIOS
        : giftConfig.appLinkAndroid;
      const altAppLinks = isIOS
        ? giftConfig.altAppLinkIOS
        : giftConfig.altAppLinkAndroid;

      if (appLinks !== "") {
        activityConfig = {
          button: isIOS ? "iOS" : "Android",
          src: appLinks,
          title: giftConfig.title,
          slug: giftConfig.slug,
          thumbnail: giftConfig.thumbnail ?? "activity-placeholder.png",
          description: giftConfig.description ?? "",
          type: "game",
        };
      } else if (giftConfig.altType === "game") {
        activityConfig = {
          button: isIOS ? "iOS" : "Android",
          src: altAppLinks,
          title: giftConfig.altTitle,
          slug: giftConfig.altSlug,
          thumbnail: giftConfig.altThumbnail ?? "activity-placeholder.png",
          description: giftConfig.altDescription ?? "",
          type: "game",
        };
      } else if (giftConfig.altType === "video") {
        activityConfig = {
          button: "Default",
          src: getVideoUrl(giftConfig.altIdec),
          title: giftConfig.altTitle,
          slug: giftConfig.altSlug,
          thumbnail: giftConfig.altThumbnail ?? "activity-placeholder.png",
          description: giftConfig.altDescription ?? "",
          type: "video",
        };
      }
    } else if (giftConfig.type === "video") {
      activityConfig = {
        button: "Default",
        src: getVideoUrl(giftConfig.idec),
        title: giftConfig.title,
        slug: giftConfig.slug,
        thumbnail: giftConfig.thumbnail ?? "activity-placeholder.png",
        description: giftConfig.description ?? "",
        type: "video",
      };
    }
  }
  return activityConfig;
};
